import { render } from "./PaymentMethodCard.vue?vue&type=template&id=23c814b2&scoped=true"
import script from "./PaymentMethodCard.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCard.vue?vue&type=script&lang=js"

import "./PaymentMethodCard.vue?vue&type=style&index=0&id=23c814b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c814b2"]])

export default __exports__